"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var docs_user_agent_1 = __importDefault(require("@tencent/docs-user-agent"));
var config_1 = __importDefault(require("./config"));
var helper_1 = require("./helper");
var NetStatus;
(function (NetStatus) {
    NetStatus["OFF_LINE"] = "offline";
    NetStatus["ON_LINE"] = "online";
})(NetStatus || (NetStatus = {}));
var MAX_TRY_COUNT = 15;
var BUSY_DURATION = 60000;
var FREE_DURATION = 300000;
// 断网测试
// eslint-disable-next-line no-underscore-dangle
window.__offlinetest = false;
var visibilityChange;
if (typeof document.hidden !== 'undefined') {
    visibilityChange = 'visibilitychange';
}
else if (typeof document.mozHidden !== 'undefined') {
    visibilityChange = 'mozvisibilitychange';
}
else if (typeof document.msHidden !== 'undefined') {
    visibilityChange = 'msvisibilitychange';
}
else if (typeof document.webkitHidden !== 'undefined') {
    visibilityChange = 'webkitvisibilitychange';
}
/**
 * 网络状态管理
 */
var NetworkManager = /** @class */ (function () {
    function NetworkManager(options) {
        var _this = this;
        this.cdnSources = config_1.default.cdnSources;
        this.autoRun = config_1.default.autoRun;
        this.duration = config_1.default.duration;
        this.counter = 0;
        /**
         * 页面不可见,暂停检查
         */
        this.handleVisibility = function () {
            if (document.hidden || document.webkitHidden || document.msHidden || document.mozHidden) {
                _this.duration = FREE_DURATION;
                _this.pause();
                _this.startCheck();
            }
            else {
                _this.duration = BUSY_DURATION;
                _this.pause();
                _this.startCheck();
            }
        };
        /**
         * 「online」与「offline」事件变化
         */
        this.handleNetstatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.netcheck()];
                    case 1:
                        _a.status = _b.sent();
                        this.handleCalback();
                        return [2 /*return*/];
                }
            });
        }); };
        this.setConfig(options);
        this.status = this.navigatorOnlineStatus;
        this.netchecksource = this.cdnSources[0];
        this.callbacks = [];
        // autoRun为false, 不执行初始化
        if (!this.autoRun) {
            return;
        }
        this.init();
    }
    NetworkManager.create = function (options) {
        var instance = new NetworkManager(options);
        return instance;
    };
    NetworkManager.getInstance = function (options) {
        if (!NetworkManager.instance) {
            NetworkManager.instance = NetworkManager.create(options);
        }
        return NetworkManager.instance;
    };
    NetworkManager.prototype.setConfig = function (options) {
        var _a = options.cdnSources, cdnSources = _a === void 0 ? this.cdnSources : _a, _b = options.ignoreDefaultSources, ignoreDefaultSources = _b === void 0 ? config_1.default.ignoreDefaultSources : _b, _c = options.autoRun, autoRun = _c === void 0 ? this.autoRun : _c, _d = options.duration, duration = _d === void 0 ? this.duration : _d;
        if (Array.isArray(cdnSources)) {
            if (ignoreDefaultSources) {
                this.cdnSources = cdnSources;
            }
            else {
                this.cdnSources = this.cdnSources.concat(cdnSources);
            }
        }
        this.autoRun = !!autoRun;
        if (Number.isInteger(duration)) {
            this.duration = duration;
        }
    };
    NetworkManager.prototype.getVersion = function () {
        return NetworkManager.version;
    };
    /**
     * 初始化
     */
    NetworkManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.preNetCheck()];
                    case 1:
                        status = _a.sent();
                        this.status = status;
                        this.bindVisibility();
                        this.bindNetStatus();
                        this.startCheck();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(NetworkManager.prototype, "isOnline", {
        /**
         * 检查是否在线
        */
        get: function () {
            // eslint-disable-next-line no-underscore-dangle
            if (window.__offlinetest) {
                return false;
            }
            return this.status === NetStatus.ON_LINE;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 绑定网络变化回掉
     * @param callback
     */
    NetworkManager.prototype.changeEnd = function (callback) {
        this.callbacks.push(callback);
    };
    /**
     * 转移回调函数, 用于新版本更新
     * @param callbacks
     */
    NetworkManager.prototype.extendCallbacks = function (callbacks) {
        this.callbacks = this.callbacks.concat(callbacks.slice());
    };
    /**
     * 获取所有回调函数
     */
    NetworkManager.prototype.getCallbacks = function () {
        return this.callbacks;
    };
    /**
     * 移除绑定
     * @param callback
    */
    NetworkManager.prototype.remove = function (callback) {
        var list = this.callbacks.slice(0, this.callbacks.length);
        for (var i = 0; i < list.length; i++) {
            if (list[i] === callback) {
                list.splice(i, 1);
                this.callbacks = list;
            }
        }
    };
    /**
     * 处理回调
     */
    NetworkManager.prototype.handleCalback = function () {
        var _this = this;
        this.callbacks.forEach(function (callback) {
            callback(_this.status);
        });
    };
    NetworkManager.prototype.destory = function () {
        if (window.mqq && docs_user_agent_1.default.isAndroid && (docs_user_agent_1.default.isTencentDocsApp || docs_user_agent_1.default.isTimOrQQ) && !docs_user_agent_1.default.isQQMiniProgram) {
            window.mqq.removeEventListener('qbrowserVisibilityChange', this.handleVisibility);
        }
        else {
            document.removeEventListener(visibilityChange, this.handleVisibility);
        }
        this.pause();
        window.removeEventListener(NetStatus.ON_LINE, this.handleNetstatus);
        window.removeEventListener(NetStatus.OFF_LINE, this.handleNetstatus);
    };
    NetworkManager.prototype.bindNetStatus = function () {
        window.addEventListener(NetStatus.ON_LINE, this.handleNetstatus);
        window.addEventListener(NetStatus.OFF_LINE, this.handleNetstatus);
    };
    /**
     * 绑定页面可视状态
     */
    NetworkManager.prototype.bindVisibility = function () {
        if (window.mqq && docs_user_agent_1.default.isAndroid && (docs_user_agent_1.default.isTencentDocsApp || docs_user_agent_1.default.isTimOrQQ) && !docs_user_agent_1.default.isQQMiniProgram) {
            window.mqq.addEventListener('qbrowserVisibilityChange', this.handleVisibility);
        }
        else {
            document.addEventListener(visibilityChange, this.handleVisibility);
        }
    };
    /**
     * 暂停检查
     */
    NetworkManager.prototype.pause = function () {
        clearInterval(this.Timer);
        this.Timer = null;
    };
    /**
     * 启动检查
     */
    NetworkManager.prototype.startCheck = function () {
        var _this = this;
        // 循环检测
        this.Timer = window.setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.polling()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, this.duration);
    };
    /**
     * 进行持续检查
     */
    NetworkManager.prototype.polling = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.preCheckOnlineStatus) return [3 /*break*/, 1];
                        this.status = this.navigatorOnlineStatus;
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this.netcheck()];
                    case 2:
                        _a.status = _b.sent();
                        _b.label = 3;
                    case 3:
                        if (!(this.counter >= MAX_TRY_COUNT)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.preNetCheck()];
                    case 4:
                        _b.sent();
                        this.counter = 0;
                        return [3 /*break*/, 6];
                    case 5:
                        this.counter += 1;
                        _b.label = 6;
                    case 6:
                        this.handleCalback();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(NetworkManager.prototype, "navigatorOnlineStatus", {
        get: function () {
            return window.navigator.onLine ? NetStatus.ON_LINE : NetStatus.OFF_LINE;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进行 CDN 资源预检, 使用最快相应的资源
     * @returns Promise<string>
     */
    NetworkManager.prototype.preNetCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var preNetCheckPromises = _this.cdnSources.map(function (value) { return _this.sourceCheck(value); });
                        helper_1.promiseAny(preNetCheckPromises)
                            .then(function (url) {
                            _this.preCheckOnlineStatus = true;
                            _this.netchecksource = url;
                            resolve(NetStatus.ON_LINE);
                            // 检查所有的图片资源是否能成功加载, 只要有能够成功加载的, 就使用这个资源
                        })
                            .catch(function () {
                            _this.preCheckOnlineStatus = false;
                            resolve(NetStatus.OFF_LINE);
                        });
                    })];
            });
        });
    };
    /**
     * 进行资源检查
     * @param url
     * @return void
     */
    NetworkManager.prototype.sourceCheck = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var preImage;
            return __generator(this, function (_a) {
                preImage = new Image();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        preImage.onload = function () {
                            resolve(url);
                        };
                        preImage.onerror = function () {
                            // 失败设置resolve全部走then,不走catch
                            reject(url + " load fail");
                        };
                        preImage.src = url + "?t=" + Date.now();
                    })];
            });
        });
    };
    /**
     * 进行网络检查
     * @returns Promise<string>
     */
    NetworkManager.prototype.netcheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.netcheckImage) {
                    this.netcheckImage = new Image();
                }
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.netcheckImage.onload = function () {
                            resolve(NetStatus.ON_LINE);
                        };
                        _this.netcheckImage.onerror = function () {
                            resolve(NetStatus.OFF_LINE);
                        };
                        _this.netcheckImage.src = _this.netchecksource + "?t=" + Date.now();
                    })];
            });
        });
    };
    NetworkManager.version = config_1.default.version;
    return NetworkManager;
}());
exports.default = NetworkManager;
//# sourceMappingURL=network-manager.js.map